import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import api from '../services/api';
import type StudyModel from '../models/StudyModel';
import type StudyQuestionModel from '../models/StudyQuestionModel';
import Table from './Table';
import CreateStudyQuestionForm from './CreateStudyQuestionForm';

type PropTypes = {
    study?: StudyModel;
};

const StudyQuestions = ({ study }: PropTypes) => {
    const [questions, setQuestions] = useState<StudyQuestionModel[]>([]);
    const [addingQuestion, setAddingQuestion] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState<
        StudyQuestionModel | undefined
    >(undefined);

    const pullQuestions = async () => {
        const { questions, success } = await api.getStudyQuestions(study?.id);
        if (success) {
            setQuestions(questions);
        }
    };

    useEffect(() => {
        void pullQuestions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteQuestion = async (studyId: number, questionId: number) => {
        const success = await api.removeQuestionFromStudy(studyId, questionId);
        if (success) {
            setSelectedQuestion(undefined);
            void pullQuestions();
        }
    };

    const onQuestionCreated = () => {
        setAddingQuestion(false);
        void pullQuestions();
    };

    const columns = [
        'id',
        'study_id',
        'study_name',
        'question_id',
        'question',
        'type',
    ];

    return (
        <div>
            <div className="flex items-center">
                <div className="text-primary text-3xl">Study Questions</div>
                <button
                    type="button"
                    className="btn btn-primary m-4"
                    onClick={async () => {
                        setAddingQuestion(true);
                    }}
                >
                    Add Question To Study
                </button>
            </div>
            <Table
                title="Questions"
                data={questions}
                columns={columns}
                onClick={(question) => {
                    setSelectedQuestion(question as StudyQuestionModel);
                }}
            />
            {selectedQuestion !== undefined && (
                <Dialog
                    visible={selectedQuestion !== undefined}
                    header={`Study Question ${selectedQuestion.id}`}
                    onHide={() => {
                        setSelectedQuestion(undefined);
                    }}
                >
                    <p>
                        Are you sure you want to remove Question{' '}
                        {selectedQuestion.question_id} from Study{' '}
                        {selectedQuestion.study_id}?
                    </p>
                    <button
                        type="button"
                        className="btn btn-primary mt-4"
                        onClick={() => {
                            void deleteQuestion(
                                selectedQuestion.study_id,
                                selectedQuestion.question_id,
                            );
                        }}
                    >
                        Remove Question From Study
                    </button>
                </Dialog>
            )}
            {addingQuestion && (
                <Dialog
                    visible={addingQuestion}
                    header="Add Question To Study"
                    onHide={() => {
                        setAddingQuestion(false);
                    }}
                >
                    <CreateStudyQuestionForm
                        study={study}
                        onQuestionCreated={onQuestionCreated}
                    />
                </Dialog>
            )}
        </div>
    );
};

export default StudyQuestions;
